import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function RouteChangePerformanceMark() {
  const location = useLocation();

  useEffect(() => {
    performance.mark("chunk-load-end");
    performance.measure("chunk-load-timing", "chunk-load-start", "chunk-load-end");
    performance.mark("final-meaningful-paint-start");
  }, [location]);

  return null;
}
